export default class RowHeroClaims {
  public static PersonId = 'https://rowhero.com/userId';
  public static TeamIds = 'https://rowhero.com/teamIds';
  public static CoachedTeamIds = 'https://rowhero.com/coachedTeamIds';
}